import logo from '../logo.png';
import "../loader.css";
import useImageCacheIndexedDb from "../services/useImageCacheIndexedDb";
import { getCategoryColor, getCategoryGradient, getCategoryIcon } from '../utility/colorForCategoryUtils';
import { getRandomIconColors } from '../utility/colorUtils';
import "../CategoryCard.css";
import { useEffect, useState } from 'react';


const CategoryCard = ({category, handleClick, idx }) => {
    const { image, loading, error } = useImageCacheIndexedDb(category?.photo || logo);
    const icon = getCategoryIcon(category?.name);
    const gradient = getRandomIconColors().background;
    const colors = getCategoryColor(idx);
    const hasRealImage = category?.photo;
    const showIcon = !hasRealImage || error;

  
    // if (loading) {
    //     return <div className="category-card my-color-bg-light-1">
    //             <img src={logo} alt={"loading.."} className="category-image m-2" />
    //             {/* <div className="loader_image m-4"></div> */}
    //             <div className="category-name">{category?.name}</div>
    //           </div>;
    // }

    return (

      // start: old category cord
        // <div className="category-card my-color-bg-light-1" onClick={() => handleClick(category)}>
        //   <img src={image} alt={category?.name} className="category-image-home" onError={(e) => {
        //           e.target.src = logo;}}/>
        //   <div className="category-name">{category?.name}</div>
        // </div>
        // end : old category cord

        
        // start: new category cord
      <div className="lp-cat-card category-card" 
       onClick={() => handleClick(category)} >
        {/* Image area */}
        <div className="lp-cat-card__img-wrap rounded" style={{ background: colors.bg}}>
          {loading || showIcon ? (
            // Loading state — show gradient placeholder
            <div className="lp-cat-card__icon-bg">
              <i className={`fa ${icon} lp-cat-card__fa`} style={{color: colors.text}}/>
            </div>
          ) : (
            // Has real category image — show it with tinted bg [style={{ background: gradient }}]
            <div className="lp-cat-card__icon-bg">
              <img
                src={image}
                alt={category?.name} 
                className="lp-cat-card__img" 
                onError={() => console.log('error test sdsdsdad')}
                decoding="async"
              />
            </div>
          )}
        </div>

        {/* Label — darker shade of same color */}
        <div className="lp-cat-card__label-wrap rounded" style={{background: colors.bg }}>
          <span className="lp-cat-card__pill" style={{ color: colors.text }}>{category?.name}</span>
        </div>
    </div>
        // start: end category cord

      );
  }
  
  export default CategoryCard;
